import { useLoadingSpinnerStore } from "~/stores/ui/loadingspinnerstore";

/**
 * Wraps an async function in a try finally block that displays a loading spinner
 * @param promise
 */
export async function withLoading<T>(promise: Promise<T>): Promise<T> {
  const loadingStore = useLoadingSpinnerStore();
  loadingStore.start();
  try {
    return await promise;
  } finally {
    loadingStore.stop();
  }
}
